import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import '../../styles/AboutPage.scss';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Arrow from '../common/Arrow';
import { Helmet } from 'react-helmet-async';

const AboutPage = () => {
  // Importa tutte le immagini dalla directory specificata
  const importAll = (r) => {
    return r.keys().map(r);
  };
  
  // Recupera le immagini dalla directory 'others'
  const images = importAll(require.context('../../assets/images/restaurant/others', false, /\.(png|jpe?g|svg|JPG)$/));

  return (
    <div className="about-page">
      <Helmet>
        <title>Chi siamo - CosyHole</title>
        <meta name="description" content="Pizzeria Birreria CosyHole - Benvenuti al CosyHole, un ristorante accogliente dove i sapori della tradizione incontrano l'innovazione. 
          Vieni a scoprire la nostra cucina, caratterizzata da ingredienti freschi e piatti preparati con passione." />
      </Helmet>
      <Header className="header">
        <div className='header-child'>
          <h1 data-aos="fade-right">Chi Siamo</h1>
          <Arrow data-aos="fade-in" direction="down" size="small" animated={true} />
        </div>
      </Header>

      {/* Sezione con Testo */}
      <section className="intro-section">
        <p data-aos="fade-up">
          Nato dalla passione decennale di Paolo Basili, il Cosy Hole da oltre quarant’anni propone, in un ambiente caldo e confortevole, fragranti pizze cotte al forno a legna, panini golosi, primi di ottima qualità, carni alla brace e sfiziosità di ogni genere. Oltre ad una cucina che nel tempo si è evoluta ed affinata, il Cosy Hole vanta una proposta di birre di prima qualità, dalle classiche tedesche, alle trappiste belghe  oltre alle proposte d’oltremanica, strizzando l’occhio alla nuova vena brassicola italiana ed ai piccoli birrifici artigianali marchigiani.
          Tale passione è stata ripresa e approfondita da Dino in veste di nuovo gestore del locale, con l’impegno di portare avanti una realtà sempre più legata al territorio.
          Cosy Hole, caldo e accogliente, come stare davanti al camino di casa.
        </p>
      </section>

      {/* Griglia di Immagini Piccole */}
      <section className="small-images-section">
        <div className="image-grid">
          {images.map((image, index) => (
            <div key={index} className="image-grid__item" data-aos="zoom-in">
              <Zoom classDialog="custom-overlay" zoomMargin={10}>
                <img src={image} alt={`img-${index}`} className="zoomable-image" />
              </Zoom>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
